import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
// State Import
import { useAccountBalanceList } from "../../state/accountBalanceListState";
// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import AccountBalanceDetails from "./AccountBalanceDetails";
import { AccountBalanceTable } from "./AccountBalanceTable";
// MUI Imports
import Typography from "@mui/material/Typography";

export default function SettledCreditNoteList() {
  // List of open ledger entries
  const [accountBalanceList, setAccountBalanceList] = useState({
    ledger: [],
    paging: {},
    balanceDue: "0.00",
    balance: "0.00",
  });

  // Filter defaults
  const [filter, setFilter] = useUrlFilterState(
    {
      search: "",
      page: 1,
      pageSize: 25,
    },
    { exclude: ["pageSize"] },
  );

  // Fetch list of open ledger entries
  const { isError, data, error, isFetching, isSuccess } =
    useAccountBalanceList(filter);

  // Success Function
  const successFunc = () => {
    setAccountBalanceList(data.data.data.data.list);
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <GenericListHeader heading={"Account Balance"} />
      {isError && <Typography>Error: {error.message}</Typography>}
      {isSuccess && (
        <>
          <AccountBalanceDetails
            balance={accountBalanceList.balance}
            balanceDue={accountBalanceList.balanceDue}
            currencyCode={null}
          />
          <AccountBalanceTable
            data={accountBalanceList}
            loading={isFetching}
            filter={filter}
            setFilter={setFilter}
          />
        </>
      )}
    </>
  );
}
